import { useCallback, useEffect, useState } from "react";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { GetUsernamesRequest, User } from "../proto/api_pb";

type ReturnType = {
  allUsers: User[];
  featuredUsers: User[];
  regularUsers: User[];
  isAllUsersLoading: boolean;
  getAllUsers: () => Promise<void>;
};
export const useGetAllUsers = (): ReturnType => {
  const [allUsers, setAllUsers] = useState<Array<User>>([]);
  const [regularUsers, setRegularUsers] = useState<Array<User>>([]);
  const [featuredUsers, setFeaturedUsers] = useState<Array<User>>([]);

  const [isLoading, setIsLoading] = useState(false);

  const getAllUsers = useCallback(async () => {
    try {
      setIsLoading(true);
      const ommuseClient: OmmuseClient = new OmmuseClient(
        process.env.REACT_APP_API_URL!
      );
      const metadata = {
        "Access-Control-Allow-Origin": "*",
      };

      const request = new GetUsernamesRequest();

      ommuseClient.getUsernames(request, metadata, (err, response) => {
        if (err) {
          console.log("Get Username List Error");
          console.log(err.message);
          setIsLoading(false);
        } else {
          const featuredUserNameList = response.getFeaturedUsersList();
          const regularUserNameList = response.getRegularUsersList();
          const userNameList = featuredUserNameList.concat(regularUserNameList);
          setAllUsers(userNameList);
          setFeaturedUsers(featuredUserNameList);
          setRegularUsers(regularUserNameList);
          setIsLoading(false);
        }
      });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  return {
    allUsers,
    featuredUsers,
    regularUsers,
    isAllUsersLoading: isLoading,
    getAllUsers,
  };
};
